/**
 * HTML and text manipulation utilities
 */

/**
 * Strip HTML tags from a string
 */
export function stripHtml(text: string): string {
    if (!text) return '';
    return text.toString().replace(/(<([^>]+)>)/gi, '');
}

/**
 * Strip style tags and their content from HTML
 */
export function stripStyle(html: string): string {
    if (!html) return '';
    return html
        .toString()
        .replace(/<style>[^</]*<\/style>/gi, '')
        .replace(/^\s*[\r\n]/gm, '');
}

/**
 * Strip both style tags and all HTML tags
 */
export function stripStyleAndHtml(html: string): string {
    if (!html) return '';
    return stripHtml(stripStyle(html));
}

/**
 * Highlight search terms in text with bold tags
 */
export function highlightSearch(text: string, searchTerm: string): string {
    const cleanText = stripHtml(text || '');
    return cleanText.replace(new RegExp(searchTerm, 'gi'), (match) =>
        searchTerm.length > 0 ? `<b>${match}</b>` : match,
    );
}
